import clsx from "clsx";

export const DASHBOARD_STATS_CLASSES = {
  container: clsx(
    "bg-white shadow-raro sm:rounded-lg overflow-hidden",
    "px-4 py-5 sm:p-6"
  ),
  header: clsx("flex items-center justify-between"),
  title: clsx(
    "text-lg font-medium leading-6 text-raro-gray-900 font-montserrat"
  ),
  subtitle: clsx("mt-1 text-sm text-raro-gray-500", "font-montserrat"),
  iconContainer: clsx("bg-primary-50 p-3 rounded-full"),
  totalValue: clsx("text-4xl font-bold text-primary-600 font-montserrat"),
  totalLabel: clsx("ml-2 text-sm font-medium text-raro-gray-500"),
  seniorityCard: clsx("bg-raro-gray-50 rounded-lg p-3"),
  seniorityLabel: clsx(
    "text-sm font-medium text-raro-gray-500 font-montserrat"
  ),
  seniorityValue: clsx(
    "mt-1 text-lg font-semibold text-raro-gray-900 font-montserrat"
  ),
};
